
namespace TabAurous.Purchase {

    @Serenity.Decorators.registerClass()
    export class QuotationLaborGrid extends Serenity.EntityGrid<QuotationLaborRow, any> {
        protected getColumnsKey() { return 'Purchase.QuotationLabor'; }
        protected getIdProperty() { return QuotationLaborRow.idProperty; }
        protected getInsertPermission() { return QuotationLaborRow.insertPermission; }
        protected getLocalTextPrefix() { return QuotationLaborRow.localTextPrefix; }
        protected getService() { return QuotationLaborService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}